<div class="container-fluid">

    <div class="row">

        <div class="col-sm-12">

            <div class="card">

                <div class="col-12" *ngIf=" (caseDetails && caseDetails.settings.allowEditInvestigation)">
                    <button class="btn btn-primary m-3" (click)="openModal(addMember)">
                        <i class="fa fa-plus-circle">
                        </i>
                        <span >
                            {{'InsertMembers' | translate}}
                        </span>
                    </button>
                </div>
                <div class="me-3 ms-2">

                    <!-- المُتسترين -->
                    <div *ngIf="caseDetails && caseDetails.caseType.concealmentInMembers" class="card p-4 me-4">

                        <h3>
                            {{ "sneakies" | translate }}
                        </h3>
                        <table class="table table-striped mt-3">

                            <thead class="thead-dark">

                                <tr>

                                    <th>
                                        {{ "personName" | translate }}
                                    </th>
                                    <th>
                                        {{ "IdentityType" | translate }}

                                    </th>
                                    <th>
                                        {{ "IdentityNumber" | translate }}
                                    </th>
                                    
                                    <th>
                                        {{ "MemberStatus" | translate }}
                                    </th>

                                    <th>
                                        {{ "Nationality" | translate }}
                                    </th>

                                    <th>
                                        {{ "MasterMember" | translate }}
                                    </th>

                                    <th>
                                        {{ "HasCriminalRecord" | translate }}
                                    </th>

                                    <th>
                                        {{ "Preview" | translate }}
                                    </th>


                                    <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        {{ "Edit" | translate }}
                                    </th>

                                    <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        {{ "Delete" | translate }}
                                    </th>

                                </tr>

                            </thead>

                            <tbody>
                                <tr *ngFor="let member of sneakiesArr">
                                    <td>
                                        {{ member.name }}
                                    </td>
                                    <td>
                                        {{ member.identityTypeName ? member.identityTypeName : "-" }}
                                    </td>
                                    <td>
                                        {{ member.nationIdOrIqama }}
                                    </td>
                                   
                                    <td>
                                        {{ member.memberStatusName }}
                                    </td>
                                    <td>
                                        <i class="flag-icon flag-icon-{{member.nationalityFlag}}">
                                        </i>
                                        {{ member.nationalityName }}
                                    </td>
                                    <td *ngIf="member.isMain">
                                        {{ "Yes" | translate }}
                                    </td>
                                    <td *ngIf="!member.isMain">
                                        {{ "No" | translate }}
                                    </td>
                                    <td *ngIf="member.hasCriminalRecord">
                                        <a href="/criminalRecords/persons/{{member.nationIdOrIqama}}" target="_blank" style="text-decoration: underline;">
                                            {{ "Yes" | translate }}
                                        </a>
                                    </td>
                                    <td *ngIf="!member.hasCriminalRecord">
                                        {{ "No" | translate }}
                                    </td>
                                    <td>
                                        <a (click)="previewMember(member, previewMemberModal)">
                                            <i class="fa fa-eye">
                                            </i>
                                        </a>
                                    </td>
                                    <td *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        <a (click)="editMember(member, editMemberModal)">
                                            <i class="fa fa-edit">
                                            </i>
                                        </a>
                                    </td>
                                    <td *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        <a (click)="deleteMember(member.caseMemberId, deleteModal)">
                                            <i class="fa fa-trash">
                                            </i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>

                        </table>

                    </div>
                    <!-- المُتستر عليهم -->
                    <div *ngIf="caseDetails && caseDetails.caseType.concealmentInMembers" class="card p-4 me-4">
                        <h3>
                            {{ "sneakyAboutThem" | translate }}
                        </h3>
                        <table class="table table-striped mt-3">
                            <thead class="thead-dark">
                                <tr>
                                    <th>
                                        {{ "personName" | translate }}
                                    </th>
                                    <th>
                                        {{ "IdentityType" | translate }}

                                    </th>
                                    <th>
                                        {{ "IdentityNumber" | translate }}
                                    </th>
                                    
                                    <th>
                                        {{ "MemberStatus" | translate }}
                                    </th>
                                    <th>
                                        {{ "Nationality" | translate }}
                                    </th>
                                    <th>
                                        {{ "MasterMember" | translate }}
                                    </th>
                                    <th>
                                        {{ "HasCriminalRecord" | translate }}
                                    </th>
                                    <th>
                                        {{ "Preview" | translate }}
                                    </th>
                                    <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        {{ "Edit" | translate }}
                                    </th>
                                    <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        {{ "Delete" | translate }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let member of sneakyAboutThemArr">
                                    <td>
                                        {{ member.name }}
                                    </td>
                                    <td>
                                        {{ member.identityTypeName ? member.identityTypeName : "-" }}
                                    </td>
                                    <td>
                                        {{ member.nationIdOrIqama }}
                                    </td>
                                    <td>
                                        {{ member.memberStatusName }}
                                    </td>
                                    <td>
                                        <i class="flag-icon flag-icon-{{member.nationalityFlag}}">
                                        </i>
                                        {{ member.nationalityName }}
                                    </td>
                                    <td *ngIf="member.isMain">
                                        {{ "Yes" | translate }}
                                    </td>
                                    <td *ngIf="!member.isMain">
                                        {{ "No" | translate }}
                                    </td>
                                    <td *ngIf="member.hasCriminalRecord">
                                        <a href="/criminalRecords/persons/{{member.nationIdOrIqama}}" target="_blank" style="text-decoration: underline;">
                                            {{ "Yes" | translate }}
                                        </a>
                                    </td>
                                    <td *ngIf="!member.hasCriminalRecord">
                                        {{ "No" | translate }}
                                    </td>
                                    <td>
                                        <a (click)="previewMember(member, previewMemberModal)">
                                            <i class="fa fa-eye">
                                            </i>
                                        </a>
                                    </td>
                                    <td *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        <a (click)="editMember(member, editMemberModal)">
                                            <i class="fa fa-edit">
                                            </i>
                                        </a>
                                    </td>
                                    <td *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        <a (click)="deleteMember(member.caseMemberId, deleteModal)">
                                            <i class="fa fa-trash">
                                            </i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                    <!-- المخالفين في الغش -->
                    <div *ngIf="caseDetails && !caseDetails.caseType.concealmentInMembers" class="card p-4 me-4">
                        <h3>
                            {{ "Offenders" | translate }}
                        </h3>
                        <table class="table table-striped mt-3">
                            <thead class="thead-dark">
                                <tr>
                                    <th>
                                        {{ "personName" | translate }}
                                    </th>
                                    <th>
                                        {{ "IdentityType" | translate }}

                                    </th>
                                    <th>
                                        {{ "IdentityNumber" | translate }}
                                    </th>
                                    <th *ngIf="caseDetails && caseDetails.caseTypeId!=4">
                                        {{ "MemberStatus" | translate }}
                                    </th>
                                    <th>
                                        {{ "Nationality" | translate }}
                                    </th>
                                    <th *ngIf="caseDetails && caseDetails.caseTypeId!=4">
                                        {{ "MasterMember" | translate }}
                                    </th>
                                    <th>
                                        {{ "HasCriminalRecord" | translate }}
                                    </th>
                                    <th>
                                        {{ "Preview" | translate }}
                                    </th>
                                    <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        {{ "Edit" | translate }}
                                    </th>
                                    <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        {{ "Delete" | translate }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let member of offendersArr">
                                    <td>
                                        {{ member.name }}
                                    </td>
                                    <td>
                                        {{ member.identityTypeName ? member.identityTypeName : "-" }}
                                    </td>
                                    <td>
                                        {{ member.nationIdOrIqama }}
                                    </td>
                                    <td *ngIf="caseDetails && caseDetails.caseTypeId!=4">
                                        {{ member.memberStatusName }}
                                    </td>
                                    <td>
                                        <i class="flag-icon flag-icon-{{member.nationalityFlag}}">
                                        </i>
                                        {{ member.nationalityName }}
                                    </td>
                                    <td *ngIf="member.isMain && caseDetails && caseDetails.caseTypeId!=4">
                                        {{ "Yes" | translate }}
                                    </td>
                                    <td *ngIf="!member.isMain && caseDetails && caseDetails.caseTypeId!=4">
                                        {{ "No" | translate }}
                                    </td>
                                    <td *ngIf="member.hasCriminalRecord">
                                        <a href="/criminalRecords/persons/{{member.nationIdOrIqama}}" target="_blank" style="text-decoration: underline;">
                                            {{ "Yes" | translate }}
                                        </a>
                                    </td>
                                    <td *ngIf="!member.hasCriminalRecord">
                                        {{ "No" | translate }}
                                    </td>
                                    <td>
                                        <a (click)="previewMember(member, previewMemberModal)">
                                            <i class="fa fa-eye">
                                            </i>
                                        </a>
                                    </td>
                                    <td *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        <a (click)="editMember(member, editMemberModal)">
                                            <i class="fa fa-edit">
                                            </i>
                                        </a>
                                    </td>
                                    <td *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        <a (click)="deleteMember(member.caseMemberId, deleteModal)">
                                            <i class="fa fa-trash">
                                            </i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- أطراف القضية الغير متهمين -->
                    <div *ngIf="caseDetails && caseDetails.caseType.id != 4" class="card p-4 me-4">

                        <h3>
                            {{ "partiesCaseNotAccused" | translate }}
                        </h3>
                        <table class="table table-striped mt-3">

                            <thead class="thead-dark">

                                <tr>

                                    <th>
                                        {{ "personName" | translate }}
                                    </th>

                                    <th>
                                        {{ "IdentityType" | translate }}

                                    </th>
                                    <th>
                                        {{ "IdentityNumber" | translate }}
                                    </th>
                                    <th>
                                        {{ "MemberType" | translate }}
                                    </th>

                                    <th>
                                        {{ "MemberStatus" | translate }}
                                    </th>

                                    <th>
                                        {{ "Nationality" | translate }}
                                    </th>

                                    <th>
                                        {{ "MasterMember" | translate }}
                                    </th>

                                    <th>
                                        {{ "HasCriminalRecord" | translate }}
                                    </th>

                                    <th>
                                        {{ "Preview" | translate }}
                                    </th>


                                    <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        {{ "Edit" | translate }}
                                    </th>

                                    <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        {{ "Delete" | translate }}
                                    </th>

                                </tr>

                            </thead>

                            <tbody>
                                <tr *ngFor="let member of partiesCaseNotAccusedArr">
                                    <td>
                                        {{ member.name }}
                                    </td>
                                    <td>
                                        {{ member.identityTypeName ? member.identityTypeName : "-" }}
                                    </td>
                                    <td>
                                        {{ member.nationIdOrIqama }}
                                    </td>
                                    <td>
                                        {{ member.memberTypeName }}
                                    </td>
                                    <td>
                                        {{ member.memberStatusName }}
                                    </td>
                                    <td>
                                        <i class="flag-icon flag-icon-{{member.nationalityFlag}}">
                                        </i>
                                        {{ member.nationalityName }}
                                    </td>
                                    <td *ngIf="member.isMain">
                                        {{ "Yes" | translate }}
                                    </td>
                                    <td *ngIf="!member.isMain">
                                        {{ "No" | translate }}
                                    </td>
                                    <td *ngIf="member.hasCriminalRecord">
                                        <a href="/criminalRecords/persons/{{member.nationIdOrIqama}}" target="_blank" style="text-decoration: underline;">
                                            {{ "Yes" | translate }}
                                        </a>
                                    </td>
                                    <td *ngIf="!member.hasCriminalRecord">
                                        {{ "No" | translate }}
                                    </td>
                                    <td>
                                        <a (click)="previewMember(member, previewMemberModal)">
                                            <i class="fa fa-eye">
                                            </i>
                                        </a>
                                    </td>
                                    <td *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        <a (click)="editMember(member, editMemberModal)">
                                            <i class="fa fa-edit">
                                            </i>
                                        </a>
                                    </td>
                                    <td *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        <a (click)="deleteMember(member.caseMemberId, deleteModal)">
                                            <i class="fa fa-trash">
                                            </i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>

                        </table>

                    </div>
                    <!-- أطراف القضية المدعيين -->
                    <div *ngIf="caseDetails && caseDetails.caseType.id == 4" class="card p-4 me-4">

                        <h3>
                            {{ "Plaintiffs" | translate }}
                        </h3>
                        <table class="table table-striped mt-3">

                            <thead class="thead-dark">

                                <tr>

                                    <th>
                                        {{ "personName" | translate }}
                                    </th>

                                    <th>
                                        {{ "IdentityType" | translate }}

                                    </th>
                                    <th>
                                        {{ "IdentityNumber" | translate }}
                                    </th>
                                    <!--<th>
                                    {{ "MemberType" | translate }}</th>
                                    -->

                                    <th>
                                        {{ "Nationality" | translate }}
                                    </th>

                                    <th>
                                        {{ "HasCriminalRecord" | translate }}
                                    </th>

                                    <th>
                                        {{ "Preview" | translate }}
                                    </th>


                                    <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        {{ "Edit" | translate }}
                                    </th>

                                    <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        {{ "Delete" | translate }}
                                    </th>

                                </tr>

                            </thead>

                            <tbody>
                                <tr *ngFor="let member of plaintiffsArr">
                                    <td>
                                        {{ member.name }}
                                    </td>
                                    <td>
                                        {{ member.identityTypeName ? member.identityTypeName : "-" }}
                                    </td>
                                    <td>
                                        {{ member.nationIdOrIqama }}
                                    </td>
                                    <td>
                                        <i class="flag-icon flag-icon-{{member.nationalityFlag}}">
                                        </i>
                                        {{ member.nationalityName }}
                                    </td>
                                    <td *ngIf="member.hasCriminalRecord">
                                        <a href="/criminalRecords/persons/{{member.nationIdOrIqama}}" target="_blank" style="text-decoration: underline;">
                                            {{ "Yes" | translate }}
                                        </a>
                                    </td>
                                    <td *ngIf="!member.hasCriminalRecord">
                                        {{ "No" | translate }}
                                    </td>
                                    <td>
                                        <a (click)="previewMember(member, previewMemberModal)">
                                            <i class="fa fa-eye">
                                            </i>
                                        </a>
                                    </td>
                                    <td *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        <a (click)="editMember(member, editMemberModal)">
                                            <i class="fa fa-edit">
                                            </i>
                                        </a>
                                    </td>
                                    <td *ngIf="caseDetails && caseDetails.settings.allowEditInvestigation">
                                        <a (click)="deleteMember(member.caseMemberId, deleteModal)">
                                            <i class="fa fa-trash">
                                            </i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>
<ng-template #addMember let-modal>

    <div class="modal-header" style="justify-content: space-between">
        <div>
        </div>
        <h4 class="modal-title" id="modal-basic-title">
            {{ "InsertMembers" | translate }}
        </h4>
        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')">
        </i>
    </div>
    <div class="modal-body">
        <div class="custom-form">
            <div class="col-12 offset-1">
                <div class="card p-3">
                    <div class="form-group row">
                        <label>
                            {{ "InputMethod" | translate }}
                        </label>
                        <div class="col-lg-4">
                            <div class="custom-control custom-checkbox" style="display: flex; align-items: center">
                                <input [checked]="inputMethod == 'manual'" (change)="inputMethodSelect('manual')" type="radio" name="inputMethod" />
                                <label style="margin-top: 4px">
                                    <span>
                                        {{ "Manual" | translate }}
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="custom-control custom-checkbox" style="display: flex; align-items: center">
                                <input [checked]="inputMethod == 'yaqeen'" (change)="inputMethodSelect('yaqeen')" type="radio" name="inputMethod" />
                                <label style="margin-top: 4px">
                                    <span>
                                        {{ "ByYaqeen" | translate }}
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div  class="col-lg-4">
                            <div class="custom-control custom-checkbox" style="display: flex; align-items: center">
                                <input [checked]="inputMethod == 'inCompany'" (change)="inputMethodSelect('inCompany')" type="radio" name="inputMethod" />
                                <label style="margin-top: 4px">
                                    <span>
                                        {{ "InCompanyOrInstitution" | translate }}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="inputMethod == 'inCompany'" class="form-group row mt-3 yaqeenBox">
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label for="PersonsCompanyName">
                                    {{ "PersonsInCompanyOrInstitution" | translate }}
                                </label>
                                <span *ngIf="PersonsCompanyName.invalid" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    <span *ngIf="PersonsCompanyName.errors?.required">
                                        *
                                    </span>
                                </span>
                            </div>
                            <ng-select id="personName" required #PersonsCompanyName="ngModel" class="form-control-select" [(ngModel)]="personsInCompanyAddPersonModalId" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'PersonsInCompanyOrInstitution' | translate }}" (change)="selectPersonINCompany($event)">
                                <ng-option *ngFor="let person of personsInCompanyAddPersonModalArr" [value]="person">
                                    {{person.name}}
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div *ngIf="isMemberFromCase" class="form-group row mt-3">
                        <div class="col-lg-12">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>{{ "CaseOffenders" | translate }}</label>
                                <span *ngIf="CaseOffenders.invalid && CaseOffenders.errors?.required" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    *
                                </span>
                            </div>
                            <ng-select id="CaseOffenders" name="CaseOffenders" required #CaseOffenders="ngModel" class="form-control-select" [items]="membersOnCaseArr" bindLabel="name" bindValue="caseMemberId"
                                [(ngModel)]="memberIdSelectedInAddFromCase" (change)="onSelectMemberFromCaseOffenders($event)" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'CaseOffenders' | translate }}">
                            </ng-select>
                        </div>
                    </div>
                    <div class="form-group row mt-3" [ngClass]="{'yaqeenBox' :inputMethod == 'yaqeen'}">
                        <div class="col-2">
                            <div class="divformlabel">
                                <label>
                                    {{ "idType" | translate }}
                                </label>
                                <span *ngIf="identityTypes.invalid && identityTypes.errors?.required" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                                    *
                                </span>
                            </div>
                            <!-- || memberTypeId==2 || memberTypeId==3 -->
                            <ng-select id="identityTypes" required #identityTypes="ngModel" [disabled]="inputMethod=='inCompany' || memberFromCaseOffender" class="form-control-select" [items]="identityTypesArr" (change)="selectIdentityType()" bindLabel="text" bindValue="id" [(ngModel)]="identityTypeId" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'idType' | translate }}">
                            </ng-select>
                        </div>
                        <div class="col-lg-4">
                            <div class="divformlabel">
                                <label>
                                    {{ "IdentityNumber" | translate }}
                                </label>
                                <span *ngIf="IdentityNumber.invalid && IdentityNumber.errors?.required" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    *
                                </span>
                            </div>
                            <input [readOnly]="inputMethod=='inCompany' || memberFromCaseOffender" (keyup)="numberOnly($event)" required #IdentityNumber="ngModel" name="IdentityNumber" id="IdentityNumber" [(ngModel)]="identityOrIqamaNumber" type="text" class="form-control" placeholder="{{ 'IdentityNumber' | translate }}" />
                            <span class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; position: absolute;">
                               
                                <span *ngIf="!isValidIdentityNumber && !IdentityNumber.errors?.required">
                                    {{ "IdentityNumberIsNotValid" | translate }}
                                </span>
                            </span>
                        </div>
                       
                        <div *ngIf="inputMethod == 'yaqeen'" class="col-lg-6 row">
                            <div class="col-lg-9">
                                <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                    <label *ngIf="identityTypeId == 2">
                                        {{ "ExpirationDateOfResidence" | translate }}
                                    </label>
                                    <label *ngIf="identityTypeId != 2">
                                        {{ "BirthOfDate" | translate }}
                                    </label>
                                    <span *ngIf="!dateOf" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                        *
                                    </span>
                                </div>
                                <datepicker (selectedDateChange)="SelectedHijriDateChange($event)" [selectedDateType]="1" >
                                </datepicker>
                            </div>
                            <div class="col-lg-3" style=" display: flex; justify-content: center; align-items: flex-end; ">
                                <!-- !isValidIqamaNumber || -->
                                <button (click)="getYaqeenInfo()" [disabled]=" !isValidIdentityNumber || !dateOf || identityTypes.invalid || IdentityNumber.invalid " class="btn btn-primary">
                                    {{ "Search" | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label for="PersonName">
                                    {{ "personName" | translate }}
                                </label>
                                <span *ngIf="PersonName.invalid && PersonName.errors?.required" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">*</span>
                            </div>
                            <input id="personName" required [readOnly]="inputMethod=='yaqeen' || inputMethod=='inCompany' || memberFromCaseOffender" #PersonName="ngModel" class="form-control" [(ngModel)]="personName" type="text" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'personName' | translate }}" />
                        </div>
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>{{ "Nationality" | translate }}</label>
                                <span *ngIf="Nationality.invalid && Nationality.errors?.required" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; "> * </span>
                            </div>
                            <!--[disabled]="inputMethod=='inCompany' || identityTypeethod=='inCompany' || identityTypeId==1"-->
                            <ng-select id="Nationality" [disabled]="inputMethod=='inCompany' || memberFromCaseOffender || identityTypeId==1" required #Nationality="ngModel" class="form-control-select" [(ngModel)]="nationaltyId" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Nationality' | translate }}">
                                <ng-option *ngFor="let na of nationalityArr" [value]="na.id">
                                    <i class="flag-icon flag-icon-{{ na.more }}">
                                    </i>
                                    <span>
                                        {{ na.text }}
                                    </span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                                <label for="email">
                                    {{'Email'|translate}}
                                </label>
                                <span *ngIf="Email.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                                    <div *ngIf="Email.errors?.pattern">
                                        {{'ThisIsNotValidEmail'|translate}}
                                    </div>
                                </span>
                            </div>
                            <input [readOnly]="memberFromCaseOffender" #Email="ngModel" pattern='^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$' placeholder="{{'Email'|translate}}" type="email" [ngModelOptions]="{standalone: true}" [(ngModel)]="email" class="form-control" name="email" id="email">
                        </div>
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                                <label for="mobile">
                                    {{'MobileNumber'|translate}}
                                </label>
                                <span *ngIf="Mobile.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                                    <div *ngIf="Mobile.errors?.pattern">
                                        {{'ThisMobileIsInvalid' | translate}}
                                    </div>
                                </span>
                            </div>
                            <input [readOnly]="memberFromCaseOffender" #Mobile="ngModel" pattern="^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$" placeholder="{{'MobileNumber'|translate}}" type="text" [(ngModel)]="mobile" [ngModelOptions]="{standalone: true}" class="form-control" name="mobile" id="mobile" [ngModelOptions]="{standalone: true}">
                        </div>
                    </div>
                    
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "RelationshipWithTheCase" | translate }}
                                </label>
                                <span *ngIf="MemberType.invalid" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    <div *ngIf="MemberType.errors?.required">
                                        *
                                    </div>
                                </span>
                            </div>
                            <!-- (change)="changeMemberType()" -->
                            <ng-select id="MemberType" name="MemberType" required #MemberType="ngModel" class="form-control-select" [items]="memberTypesArr" bindLabel="text" bindValue="id" [(ngModel)]="memberTypeId" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'RelationshipWithTheCase' | translate }}">
                            </ng-select>
                        </div>
                        <div *ngIf="memberTypeId!==6 && caseDetails && caseDetails.caseTypeId!=4" class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "MemberStatus" | translate }}
                                </label>
                                <span *ngIf="MemberStatus.invalid" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    <span *ngIf="MemberStatus.errors?.required">
                                        *
                                    </span>
                                </span>
                            </div>
                            <ng-select id="MemberStatus" required #MemberStatus="ngModel" class="form-control-select" [items]="memberStatusArr" bindLabel="text" bindValue="id" [(ngModel)]="memberStatusId" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'MemberStatus' | translate }}">
                            </ng-select>
                        </div>
                    </div>
                    <div *ngIf="memberTypeId == 1" class="form-group row mt-3">
                        <div class="col-lg-12">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "Reason" | translate }}
                                </label>
                                <span *ngIf="Reason.invalid" class="alert" style="color: red;white-space: nowrap;line-height: 0;padding: 0;margin-top: 8px;">
                                    <span *ngIf="Reason.errors?.required">
                                        *
                                    </span>
                                </span>
                            </div>
                            <textarea id="Reason" required #Reason="ngModel" class="form-control" rows="2" [(ngModel)]="reason" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Reason' | translate }}"></textarea>
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "Description" | translate }}
                                </label>
                                <span *ngIf="memberTypeId!=1 && !description" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    *
                                </span>
                            </div>
                            <textarea [readOnly]="memberFromCaseOffender" id="Description" class="form-control" rows="2" [(ngModel)]="description" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Description' | translate }}"></textarea>
                        </div>
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "Notes" | translate }}
                                </label>
                            </div>
                            <textarea [readOnly]="memberFromCaseOffender" id="Notes" class="form-control" rows="2" [(ngModel)]="notes" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Notes' | translate }}"> </textarea>
                        </div>
                    </div>

                    <div *ngIf="memberTypeId != 1 && memberTypeId!==6 && caseDetails && caseDetails.caseTypeId!=4" class="form-group row mt-3">
                        <div class="col-lg-6 row">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "MasterMember" | translate }}
                                </label>
                                <span *ngIf="isMain === undefined" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    *
                                </span>
                            </div>
                            <div class="col-lg-6" *ngIf="caseDetails && caseDetails.caseTypeId!=4">
                                <div class="custom-control custom-checkbox" style="display: flex; align-items: center">
                                    <input [checked]="isMain == true" (change)="isMain = true" type="radio" name="isMain" />
                                    <label style="margin-top: 4px">
                                        <span>
                                            {{ "Yes" | translate }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="custom-control custom-checkbox" style="display: flex; align-items: center">
                                    <input [checked]="isMain == false" (change)="isMain = false" type="radio" name="isMain" />
                                    <label style="margin-top: 4px">
                                        <span>
                                            {{ "No" | translate }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer row" style="justify-content: space-between; padding: 1rem 2rem">


        <button *ngIf="caseDetails && caseDetails.caseTypeId!=4" (click)="CreateMember(modal)" [disabled]=" (inputMethod=='yaqeen' && (personName==null || personName=='') ) ||   identityTypes.invalid || IdentityNumber.invalid || PersonName.invalid|| !nationaltyId || !memberTypeId || (memberTypeId!=6 && !memberStatusId) || ((memberTypeId != 1 && memberTypeId!=6 ) && isMain == undefined) || (memberTypeId != 1 && description == undefined) || !isValidIdentityNumber || (memberTypeId == 1 && !reason) || (mobile && Mobile.invalid) || (Email.invalid && email)" style="color: black; font-weight: bold" type="button" class="btn btn-primary col-lg-3" data-bs-dismiss="modal">
            {{ "Add" | translate }}
        </button>


        <button *ngIf="caseDetails && caseDetails.caseTypeId==4" (click)="CreateMember(modal)" [disabled]=" (inputMethod=='yaqeen'  && (personName==null || personName=='')) ||  identityTypes.invalid || IdentityNumber.invalid || PersonName.invalid || !nationaltyId || !memberTypeId || (memberTypeId != 1 && description == undefined) || !isValidIdentityNumber || (memberTypeId == 1 && !reason) || (mobile && Mobile.invalid) || (Email.invalid && email)" style="color: black; font-weight: bold" type="button" class="btn btn-primary col-lg-3" data-bs-dismiss="modal">
            {{ "Add" | translate }}
        </button>
        <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>

    </div>

</ng-template>


<ng-template #deleteModal let-modal>
    <div class="modal-header" style="justify-content: center">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "ConfirmDeleteOperation" | translate }}
        </h4>
    </div>
    <div class="modal-body text-center">
        <p>
            {{ "SelectedRecordwillbeDeleted" | translate }}
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDeleteMember(modal)">
            {{ "Yes" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "No" | translate }}
        </button>
    </div>
</ng-template>


<ng-template #editMemberModal let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <div>
        </div>
        <h4 class="modal-title" id="modal-basic-title">
            {{ "EditMember" | translate }}
        </h4>
        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')">
        </i>
    </div>
    <div class="modal-body">
        <div class="custom-form">
            <div class="col-12 offset-1">
                <div class="card p-3">
                    <div class="form-group row">
                        <div *ngIf="editedObj.identityTypeName" class="col-lg-6">
                            <label>
                                {{ "IdentityType" | translate }}
                            </label>
                            <input readonly [(ngModel)]="editedObj.identityTypeName" type="text" class="form-control" />
                            <!-- <ng-select *ngIf="!editedObj.identityTypeName" id="identityType" required #identityType="ngModel" [disabled]="inputMethod=='inCompany' || memberFromCaseOffender" class="form-control-select" [items]="identityTypesArr" (change)="selectIdentityType()" bindLabel="text" bindValue="id" [(ngModel)]="editedObj.identityTypeId" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'idType' | translate }}">
                            </ng-select> -->
                        </div>
                        <div class="col-lg-6">
                            <label>
                                {{ "IdentityNumber" | translate }}
                            </label>
                            <input readonly [(ngModel)]="editedObj.nationIdOrIqama" type="text" class="form-control" />
                        </div>
                        
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label for="PersonNameEdit">
                                    {{ "personName" | translate }}
                                </label>
                                <span *ngIf="PersonNameEdit.invalid" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    <div *ngIf="PersonNameEdit.errors?.required">
                                        *
                                    </div>
                                </span>
                            </div>
                            <input [readOnly]="isEditedObjHasCase" id="PersonNameEdit" required #PersonNameEdit="ngModel" class="form-control" [(ngModel)]="editedObj.name" type="text" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'personName' | translate }}" />
                        </div>
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "Nationality" | translate }}
                                </label>
                                <span *ngIf="NationalityEdit.invalid" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    <div *ngIf="NationalityEdit.errors?.required">
                                        *
                                    </div>
                                </span>
                            </div>
                            <ng-select [disabled]="isEditedObjHasCase || editedObj.identityTypeId==1" id="NationalityEdit" required #NationalityEdit="ngModel" class="form-control-select" [(ngModel)]="editedObj.nationalityId" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Nationality' | translate }}">
                                <ng-option *ngFor="let na of nationalityArr" [value]="na.id">
                                    <i class="flag-icon flag-icon-{{ na.more }}">
                                    </i>
                                    <span>
                                        {{ na.text }}
                                    </span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                                <label for="email">
                                    {{'Email'|translate}}
                                </label>
                                <span *ngIf="EditEmail.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                                    <div *ngIf="EditEmail.errors?.pattern">
                                        {{'ThisIsNotValidEmail'|translate}}
                                    </div>
                                </span>
                            </div>
                            <input [readOnly]="isEditedObjHasCase" #EditEmail="ngModel" pattern='^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$' placeholder="{{'Email'|translate}}" type="email" [ngModelOptions]="{standalone: true}" [(ngModel)]="editedObj.email" class="form-control" name="email" id="email">
                        </div>
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                                <label for="mobile">
                                    {{'MobileNumber'|translate}}
                                </label>
                                <span *ngIf="EditMobile.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                                    <span *ngIf="EditMobile.errors?.pattern">
                                        {{'ThisMobileIsInvalid' | translate}}
                                    </span>
                                </span>
                            </div>
                            <input [readOnly]="isEditedObjHasCase" #EditMobile="ngModel" pattern="^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$" placeholder="{{'MobileNumber'|translate}}" type="text" [(ngModel)]="editedObj.mobile" [ngModelOptions]="{standalone: true}" class="form-control" name="mobile" id="mobile" [ngModelOptions]="{standalone: true}">
                        </div>
                    </div>
                   
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "RelationshipWithTheCase" | translate }}
                                </label>
                                <span *ngIf="MemberTypeEdit.invalid" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    <span *ngIf="MemberTypeEdit.errors?.required">
                                        *
                                    </span>
                                </span>
                            </div>
                            <!-- (change)="changeMemberType()" -->
                            <ng-select [disabled]="isEditedObjHasCase" id="MemberTypeEdit" name="MemberTypeEdit" required #MemberTypeEdit="ngModel" class="form-control-select" [items]="memberTypesArrEdit" bindLabel="text" bindValue="id" [(ngModel)]="editedObj.memberTypeId" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'RelationshipWithTheCase' | translate }}">
                            </ng-select>
                        </div>
                        <div class="col-lg-6" *ngIf="editedObj.memberTypeId !=6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "MemberStatus" | translate }}
                                </label>
                                <span *ngIf="MemberStatusEdit.invalid" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    <span *ngIf="MemberStatusEdit.errors?.required">
                                        *
                                    </span>
                                </span>
                            </div>
                            <ng-select id="MemberStatusEdit" required #MemberStatusEdit="ngModel" class="form-control-select" [items]="memberStatusArr" bindLabel="text" bindValue="id" [(ngModel)]="editedObj.memberStatusId" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'MemberStatus' | translate }}">
                            </ng-select>
                        </div>
                    </div>
                    <div *ngIf="editedObj.memberTypeId == 1" class="form-group row mt-3">
                        <div class="col-lg-12">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "Reason" | translate }}
                                </label>
                                <span *ngIf="ReasonEdit.invalid" class="alert" style="color: red;white-space: nowrap;line-height: 0;padding: 0;margin-top: 8px;">
                                    <span *ngIf="ReasonEdit.errors?.required">
                                        *
                                    </span>
                                </span>
                            </div>
                            <textarea id="ReasonEdit" required #ReasonEdit="ngModel" class="form-control" rows="2" [(ngModel)]="editedObj.reason" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Reason' | translate }}"></textarea>
                        </div>
                    </div>
                    
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "Description" | translate }}
                                </label>
                                <span *ngIf="editedObj.memberTypeId !=1 && !editedObj.description" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    *
                                </span>
                            </div>
                            <textarea [readOnly]="isEditedObjHasCase" id="DescriptionEdit" class="form-control" rows="2" [(ngModel)]="editedObj.description" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Description' | translate }}"> </textarea>
                        </div>
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "Notes" | translate }}
                                </label>
                            </div>
                            <textarea [readOnly]="isEditedObjHasCase" id="NotesEdit" required #NotesEdit="ngModel" class="form-control" rows="2" [(ngModel)]="editedObj.notes" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Notes' | translate }}"></textarea>
                        </div>
                    </div>
                    <div *ngIf="editedObj.memberTypeId != 1 && editedObj.memberTypeId != 6" class="form-group row mt-3">
                        <div class="col-lg-6 row">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>
                                    {{ "MasterMember" | translate }}
                                </label>
                                <span *ngIf="editedObj.isMain === undefined" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px; ">
                                    *
                                </span>
                            </div>
                            <div class="col-lg-6">
                                <div class="custom-control custom-checkbox" style="display: flex; align-items: center">
                                    <input [checked]="editedObj.isMain == true" (change)="editedObj.isMain = true" type="radio" name="isMain" />
                                    <label style="margin-top: 4px">
                                        <span>
                                            {{ "Yes" | translate }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="custom-control custom-checkbox" style="display: flex; align-items: center">
                                    <input [checked]="editedObj.isMain == false" (change)="editedObj.isMain = false" type="radio" name="isMain" />
                                    <label style="margin-top: 4px">
                                        <span>
                                            {{ "No" | translate }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer row" style="justify-content: space-between; padding: 1rem 2rem">
        <button (click)="onEditMember(modal)" [disabled]="(isCase && editedObj.memberTypeId ==1 && !editedObj.reason ) || !editedObj.name || !editedObj.nationalityId || (isCase && editedObj.memberTypeId !=6 && !editedObj.memberStatusId ) || (isCase && !editedObj.memberTypeId) || (isCase && memberTypeId == 1 && !editedObj.reason) || (editedObj.mobile && EditMobile.invalid) || (EditEmail.invalid && editedObj.email) || ((editedObj.memberTypeId !== 1 && editedObj.memberTypeId !=6 ) && editedObj.isMain == undefined) || (editedObj.memberTypeId !== 1 && editedObj.description == undefined ) " style="color: black; font-weight: bold" type="button" class="btn btn-primary col-lg-3" data-bs-dismiss="modal">
            {{ "Edit" | translate }}
        </button>
        <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>
</ng-template>


<ng-template #previewMemberModal let-modal>

    <div class="modal-header" style="justify-content: space-between">
        <div>
        </div>
        <h4 class="modal-title" id="modal-basic-title">
            {{ "PreviewMember" | translate }}
        </h4>
        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')">
        </i>
    </div>
    <div class="modal-body">

        <div class="custom-form">

            <div class="col-12 offset-1">

                <div class="card p-3">

                    <div class="form-group row">
                        <div *ngIf="editedObj.identityTypeName" class="col-lg-6">
                            <label>
                                {{ "IdentityType" | translate }}
                            </label>
                            <input  readonly [(ngModel)]="editedObj.identityTypeName" type="text" class="form-control" />
                             
                        </div>
                        <div class="col-lg-6">
                            <label>
                                {{ "IdentityNumber" | translate }}
                            </label>
                            <span class="form-control" readonly>
                                {{editedObj.nationIdOrIqama}}&nbsp;
                            </span>
                        </div>
                        
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <label for="PersonNameEdit">
                                {{ "personName" | translate }}
                            </label>
                            <span class="form-control" readonly>
                                {{editedObj.name}}&nbsp;
                            </span>
                        </div>
                        <div class="col-lg-6">
                            <label>
                                {{ "Nationality" | translate }}
                            </label>
                            <span class="form-control" readonly>
                                {{editedObj.nationalityName}}&nbsp;
                            </span>
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <label for="email">
                                {{'Email'|translate}}
                            </label>
                            <span class="form-control" readonly>
                                {{editedObj.email}}&nbsp;
                            </span>
                        </div>
                        <div class="col-lg-6">
                            <label for="mobile">
                                {{'MobileNumber'|translate}}
                            </label>
                            <span class="form-control" readonly>
                                {{editedObj.mobile}}&nbsp;
                            </span>
                        </div>
                    </div>
                    <div class="form-group row">
                        
                        <div *ngIf="!isCase" class="col-lg-6 mt-3">
                            <label>
                                {{ "prosecutionName" | translate }}
                            </label>
                            <span class="form-control" readonly>
                                {{editedObj.prosecutionName}}&nbsp;
                            </span>
                        </div>
                      
                        <div  class="mt-3 col-lg-6">
                            <label>
                                {{ "RelationshipWithTheCase" | translate }}
                            </label>
                            <span class="form-control" readonly>
                                {{editedObj.memberTypeName}}&nbsp;
                            </span>
                        </div>
                        
                        <div class="col-lg-6 mt-3">
                            <label>
                                {{ "MemberStatus" | translate }}
                            </label>
                            <span class="form-control" readonly>
                                {{editedObj.memberStatusName}}&nbsp;
                            </span>
                        </div>
                        
                        <div class="col-lg-6 mt-3">
                            <label>
                                {{ "Description" | translate }}
                            </label>
                            <span class="form-control" readonly>
                                {{editedObj.description}}&nbsp;
                            </span>
                        </div>
                        <div *ngIf="editedObj.notes" class="col-lg-6 mt-3">
                            <label>
                                {{ "Notes" | translate }}
                            </label>
                            <span class="form-control" readonly>
                                {{editedObj.notes}}&nbsp;
                            </span>
                        </div>
                    </div>
                    <div *ngIf="editedObj.memberTypeId == 1" class="form-group row mt-3">
                        <div class="col-lg-12">
                            <label>
                                {{ "Reason" | translate }}
                            </label>
                            <span class="form-control" readonly>
                                {{editedObj.reason}}&nbsp;
                            </span>
                        </div>
                    </div>
                    
                    <div *ngIf="editedObj.memberTypeId != 1 " class="form-group row mt-3">
                        <div class="col-lg-6">
                            <label>
                                {{ "MasterMember" | translate }}
                            </label>
                            <span class="form-control" readonly *ngIf="editedObj.isMain">
                                {{'Yes' | translate}}&nbsp;
                            </span>
                            <span class="form-control" readonly *ngIf="!editedObj.isMain">
                                {{'No' | translate}}&nbsp;
                            </span>
                        </div>
                    </div>

                </div>

            </div>

        </div>

    </div>
    <div class="modal-footer row" style="justify-content: flex-end; padding: 1rem 2rem">
        <button type="button" class="btn btn-danger col-lg-2" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>

</ng-template>